<div class="main-content mt-16">
    @if (iconSet()) {
    <div class="px-4 pb-3 pt-px product-container">
        @if (hasError) {
        <div>
            @if (showNoAccessError) {
            <div>
                <app-no-access-error></app-no-access-error>
            </div>
            } @else {
            <div class="row">
                <div class="col-12">
                    <div class="mt-3 dashboard-error">
                        <div>
                            <h3 class="text-center">{{errorMessage}}</h3>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
        } @else {
        <ng-container data-cy="dealDashboard">
            <div class="row" style="min-height: 42px">
                <div class="md:mt-4 product-container__bread-crumb grid md:col-12 md:flex md:pr-3.5">
                    <div class="col-12 md:contents">
                        @for (breadcrumb of breadcrumbs; track breadcrumb) {
                        <div class="custom-breadcrumb">
                            <a class="custom-breadcrumb__text" attr.data-cy="breadcrumb{{breadcrumb.type}}"
                                routerLinkActive="active" [routerLink]="breadcrumb.isDisabled ? null : breadcrumb.route"
                                [queryParams]="breadcrumb.isDisabled ? null : breadcrumb.queryParams"
                                (click)="breadcrumb.isDisabled ? $event.preventDefault() : breadcrumbClick(breadcrumb)"
                                [title]="breadcrumb.name" [class.disabled]="breadcrumb.isDisabled">
                                {{breadcrumb.name}}
                            </a>
                            <mat-icon class="custom-breadcrumb__icon">chevron_right</mat-icon>
                        </div>
                        }
                    </div>
                    <app-auto-adjusting-dropdown [selected]="dealNameForBreadcrumb()"
                        [dataForBreadcrumbs]="dealsForBreadcrumb()" (goToSelected)="goToSelectedDeal($event)"
                        [selectedValue]="dealId()" class="px-3.5 md:px-0" [valueProperty]="'displayId'"
                        [nameProperty]="'displayName'" [groupProperty]="'subEntities'" [type]="'Deal'"
                        data-cy="dealDropdown"></app-auto-adjusting-dropdown>
                </div>
            </div>
            <div class="grid grid-cols-1 mt-4 md:mt-0">
                <div class="flex col-span-2">
                    <div class="flex ml-auto">
                        <div>
                            <img src="{{iconSet()['icon.calendar']}}" alt="Calendar" class="mt-3.5 mr-1.5" />
                        </div>
                        <gcm-date-picker [dateOptionList]="asOfDropdownData" [date]="selectedAsOfDate()"
                            (dateChange)="updateAsOfDate($event)" [class.error-text]="isDealDataUnavailable"
                            [selectPanelClass]="'as-of-date-panel'" data-cy="asOfDateDropdown"
                            class="as-of-date mr-3"></gcm-date-picker>
                    </div>
                </div>
            </div>
            @if (isDealDataUnavailable) {
            <app-data-unavailable-card entityLabel="Deal" [selectedDate]="selectedAsOfDate()"
                [backRoute]="breadcrumbs[0]?.route" [backQueryParams]="breadcrumbs[0]?.queryParams"
                (backClick)="breadcrumbClick(breadcrumbs[0])" data-cy="errorCard">
            </app-data-unavailable-card>
            } @else {
            <div class="card detail-card bg-white">
                @if (isSingleAssetDeal) {
                    <div class="mx-0 mb-2 lg:pl-0 text-5xl detail text-charcoal-grey">
                        {{dealDetailLabel}}
                    </div>
                }
                <div class="row grid grid-cols-1 lg:grid-cols-12">
                    <div class="col-span-6"
                        [class]="isSingleAssetDeal && (assetSummary().logo || assetSummary().showAssetUrl) ? 'lg:col-span-7' : 'lg:col-span-12'">
                        <div class="row grid grid-cols-1 mt-4 md:mt-0 min-h-10">
                            <div class="md:flex items-baseline">
                                <div class="product-container__deal-name text-2xl md:text-4xl" data-cy="dealTitle">
                                    {{dealName()}}
                                </div>
                                <div class="breadcrumbAsOfDate m-0 mt-1 md:mt-1.5 p-0 md:pl-1.5 flex" data-cy="asOfDate">
                                    as of
                                    {{selectedAsOfDate() | dateFormat : 'MM/dd/yyyy'}}
                                    @if (summary.publishValuationType === 'Audit') {
                                    <div data-cy="auditPublished" class="final">
                                        --
                                        Final
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <img class="asset-image" [src]="assetClassImage[1]" [matTooltip]="assetClassImage[0]"
                            [alt]="assetClassImage[0]" matTooltipClass="blue-tooltip" matTooltipPosition="right"
                            data-cy="assetClassImage">
                    </div>
                    @if (isSingleAssetDeal) {
                    <div class="col-span-6 lg:col-span-5">
                        <div class="mx-0 lg:pl-2">
                            <div class="lg:px-0">
                                @if (assetSummary().logo) {
                                <div class="logo">
                                    <img src="{{assetSummary().logo}}" alt="Asset logo" data-cy="assetLogo">
                                </div>
                                }
                                @if (assetSummary().showAssetUrl) {
                                <span class="text-md md:text-lg my-auto text-primary underline">
                                    <a href="{{assetSummary().assetURL}}" target="_blank"
                                        (click)="activityTracking.navigateToAssetUrl('single asset deal dashboard', assetMasterId, assets[0].name, assetSummary().assetURL)">
                                        {{assetSummary().assetURL}}
                                    </a>
                                </span>
                                }
                            </div>
                        </div>
                    </div>
                    }
                </div>
                <app-deal-dashboard-summary [iconSet]="iconSet()" [dealSummaryText]="dealSummary" [dealTitle]="dealTitle" [dealSummary]="summary"></app-deal-dashboard-summary>
                @if (summary.isDropdownDeal) {
                    <div data-cy="specializedFundCard" class="card detail-card mt-5 mb-0">
                        <div class="text-center font-bold">
                            {{dealName()}} is a GCM Grosvenor Specialized Fund.
                            @if (showCommingledExperience && summary.dropdownPortfolioSeries?.length > 0) {
                                To see complete details on the Specialized Fund, click on the fund below:
                                @for (series of summary.dropdownPortfolioSeries; track $index) {
                                    <div>
                                        <a data-cy="specializedFundLink" routerLinkActive="active"
                                            routerLink="/investor/{{investorId()}}/series/{{series.masterId}}"
                                            [queryParams]="{'reportingdate':reportingPeriod()}" target="_blank"
                                            class="commingled-btn">*
                                            {{series.name}}</a>.
                                    </div>
                                }
                            }
                        </div>
                    </div>
                }
                @else {
                    <!-- Hide the charts and asset table when we have single asset deal -->
                    @if (!isSingleAssetDeal) {
                        @if (summary.currency?.toLowerCase() !== 'multiple') {
                            <div class="row mt-4 widget-row grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-0">
                                <div class="pl-0 md:pr-[30px]" tourAnchor="deal.dashboard.sector">
                                    <app-sectors-widget [widgets]="widgets" [currency]="currency"></app-sectors-widget>
                                </div>
                                <div class="pl-0" tourAnchor="deal.dashboard.geography">
                                    <app-geography-widget [widgets]="widgets" [currency]="currency" [showUSMapWidget]="true"
                                        [otherCountryNames]="otherCountryNames"></app-geography-widget>
                                </div>
                            </div>
                            <app-largest-position-widget [widgets]="widgets" [currency]="currency"></app-largest-position-widget>
                        }
                        <app-assets-detail-table [portfolioName]="portfolioName()" [seriesName]="seriesName()"
                            [asOfDate]="selectedAsOfDate()" [dealName]="dealTitle" [assets]="assets" [currency]="currency"
                            [investorId]="investorId()" [seriesId]="seriesId()" [dealId]="dealId()"
                            [reportingPeriod]="reportingPeriod()"></app-assets-detail-table>
                    }
                }
            </div>
            <!-- Show the asset summary when we have single asset deal -->
            @if (isSingleAssetDeal && !summary.isDropdownDeal) {
                <div class="card detail-card bg-white">
                    <div class="mx-0 mb-4 lg:pl-0 text-5xl detail text-charcoal-grey flex items-center">
                        {{assetDetailLabel}}
                        @if (showCaseStudy) {
                        <div class="snap-shot mr-3 ml-auto">
                            <button class="my-0 md:my-2.5 flex border-primary" (click)="getCaseStudy();"
                                data-cy="downloadCaseStudy"><img src="{{iconSet()['icon.snapshot']}}"
                                    alt="Download Case Study" class="mr-2 mt-1" />Download Case Study</button>
                        </div>
                        }
                    </div>

                    @if (showCaseStudy) {
                    <div>
                        <app-case-study [dealSummary]="summary" [caseStudyDetails]="coInvestmentCaseStudyDetails"
                            data-cy="caseStudySection"></app-case-study>
                    </div>
                    } @else {
                    <app-asset-summary [assetType]="assets[0]?.assetType" [title]="assets[0].name" [assetData]="assets[0]"
                        [summary]="assetSummary().summary" [logo]="assetSummary().logo" [showingOnDealDashboard]="true"
                        [slidingImgs]="assetSummary().slidingImgs"></app-asset-summary>
                    <!-- Will Add financial Summary widget here once the data is available for the same -->
                    }
                </div>
            }
            }
        </ng-container>
        }
    </div>
    }
</div>